export default {
  LIST_FETCHED: 'PRESTACAO_DE_CONTAS_FETCHED',
  LIST_LOAD: 'PRESTACAO_DE_CONTAS_LOAD',
};
